<template>
  <div>
    <p v-html="requisitoTexto"></p>

    <h5 class="font-weight-bold my-3">Nivel Requisito de Ingreso: {{requisitos.requisitoIngreso}}</h5>

    <!-- ponderaciones -->
    <h5 class="text-azul font-weight-bold mb-3">Vías de Ingreso:</h5>

    <div class="calendario mb-2">
      <div class="fc fc-ltr fc-grid row mx-n1">
        <div class="col p-2">
          <div class="fc-day-number d-flex align-items-center" style="min-height: 29px;">
            <span class="mx-auto">LICENCIA DE ENSEÑANZA MEDIA</span>
          </div>
          <div class="fc-day-content d-flex align-items-center" style="min-height: 53px;">
            <span class="mx-auto">{{requisitos.licenciaEnsenanzaMedia}}</span>
          </div>
        </div>

        <div class="col p-2">
          <div class="fc-day-number d-flex align-items-center" style="min-height: 29px;">
            <span class="mx-auto">NOTAS DE ENSEÑANZA MEDIA</span>
          </div>
          <div class="fc-day-content d-flex align-items-center" style="min-height: 53px;">
            <span class="mx-auto">{{textoNotas}}</span>
          </div>
        </div>
      </div>

      <div class="fc fc-ltr fc-grid row mx-n1">
        <div class="col p-2">
          <div class="fc-day-number d-flex align-items-center" style="min-height: 29px;">
            <span class="mx-auto">RECONOCIMIENTO DE APRENDIZAJES PREVIOS</span>
          </div>
          <div class="fc-day-content d-flex align-items-center" style="min-height: 53px;">
            <span class="mx-auto">{{requisitos.reconocimientoAprendizajesPrevios}}</span>
          </div>
        </div>

        <div class="col p-2">
          <div class="fc-day-number d-flex align-items-center" style="min-height: 29px;">
            <span class="mx-auto">EXPERIENCIA LABORAL SOBRE 3 AÑOS</span>
          </div>
          <div class="fc-day-content d-flex align-items-center" style="min-height: 53px;">
            <span class="mx-auto">{{requisitos.experienciaLaboral}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- fin ponderaciones -->

    <h5
      v-if="requisitos.otrosRequisitos.length>0"
      class="text-azul font-weight-bold my-3"
    >Información Adicional:</h5>
    <ul class="req-list" v-if="requisitos.otrosRequisitos.length>0">
      <li v-for="req in requisitos.otrosRequisitos" :key="req.index">{{req}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "RequisitosIngreso",
  props: { requisitos: { type: Object }, requisitoTexto: { type: String } },
  computed: {
    textoNotas() {
      if (
        this.requisitos.notasEnsenanzaMedia === "SI" ||
        this.requisitos.notasEnsenanzaMedia === "SÍ"
      ) {
        return `${this.requisitos.notasEnsenanzaMedia} - Promedio ${this.requisitos.promedioEnsenanzaMedia}`;
      } else {
        return this.requisitos.notasEnsenanzaMedia;
      }
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/fichaCarreraTP/RequisitosIngreso.vue